import { createContext } from 'react';

/**
 * True while visualisations render on a deep-analysis page, where the per-item
 * "Details" content should be shown inline on the page instead of being tucked
 * behind the info-icon popover/modal.
 *
 * `CardHeaderInfoPopover` (the single choke point every visualisation's Details
 * popover flows through) reads this: when true it renders the content as an
 * inline block; when false it renders the usual icon + modal. The docking
 * controls (`DashboardFilterBar`, `DashboardCardOptions`) also read it as the
 * deep-analysis mode flag to switch to their labelled-button appearance.
 * Defaults to `false` so dashboard and analysis-grid cards keep the popover
 * and the icon controls.
 *
 * @type {React.Context<boolean>}
 */
const InlineDetailsContext = createContext(false);

export default InlineDetailsContext;
